<template>
  <div class="page">
    <div class="pageTitleBox">
      <div class="boxNameL">活体退换货订单详情</div>
      <div class="boxNameR">
        <el-button type="warning" @click="$router.back()" size="small"
          >返回</el-button
        >
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">退单编号:</div>
        <div class="msgValue">{{ objInfo ? objInfo.retrun_order_no : "" }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">原订单编号:</div>
        <div class="msgValue">
          {{ objInfo ? objInfo.return_pet.order_no : "" }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">顾客:</div>
        <div class="msgValue">
          {{ objInfo ? objInfo.user_info.nick_name : "" }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">电话:</div>
        <div class="msgValue">{{ objInfo.user_info.user_mobile }}</div>
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">退换方式：</div>
        <div class="msgValue">
          活体{{ objInfo.type == 1 ? "退宠" : "" }}
          {{ objInfo.type == 2 ? "换宠" : "" }}
          {{ objInfo.type == 3 ? "欠宠" : "" }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">订单类型::</div>
        <div class="msgValue"></div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">是否入库:</div>
        <div class="msgValue"></div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">订单备注:</div>
        <div class="msgValue">{{ objInfo.remark }}</div>
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">订单状态:</div>
        <div class="msgValue">{{ $public.formatState(objInfo.state) }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">总计:</div>
        <div class="msgValue"></div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">创建人:</div>
        <div class="msgValue">
          {{ objInfo.create ? objInfo.create.operation_user.user_name : "" }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">操作时间:</div>
        <div class="msgValue">
          {{
            objInfo.create ? $public.FTime(objInfo.create.operation_time) : ""
          }}
        </div>
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">店铺:</div>
        <div class="msgValue">
          {{ objInfo ? objInfo.company_info.shop_name : "" }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">宠物状态:</div>
        <div class="msgValue">{{ !objInfo.is_death ? "存活" : "死亡" }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">销售人员：</div>
        <div class="msgValue">
          <span
            v-for="(item, index) in return_yue_info.sales_list"
            :key="index"
          >
            <span>{{ item.sales_name }}</span>
          </span>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">是否转余额：</div>
        <div class="msgValue">
          {{ objInfo.is_return_yue ? "转余额" : "不转余额" }}
        </div>
      </div>
    </div>

    <div
      class="msg"
      style
      v-show="objInfo.is_return_yue == false && return_account_info.bank_name"
    >
      <div class="msgItem">
        <div class="msgLabel">收款姓名:</div>
        <div class="msgValue">{{ return_account_info.bank_name }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">开户行:</div>
        <div class="msgValue">{{ return_account_info.card_no }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">银行卡号:</div>
        <div class="msgValue">{{ return_account_info.name }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel"></div>
        <div class="msgValue"></div>
      </div>
    </div>
    <div class="msg" style v-show="objInfo.is_death">
      <div class="msgItem">
        <div class="msgLabel">死亡日期:</div>
        <div class="msgValue">
          {{ $public.FTime(objInfo.death_info.death_date) }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">死亡图片:</div>
        <div class="msgValue">
          <span
            v-for="(item, index) in objInfo.death_info.death_img"
            :key="index"
          >
            <img :src="item" alt style="width: 30px" />
          </span>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">死亡说明:</div>
        <div class="msgValue">{{ objInfo.death_info.death_remark }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel"></div>
        <div class="msgValue"></div>
      </div>
    </div>

    <div v-show="new_pet_infoList.length">
      <div class="orderInfo" style="margin: 10px 0px">新换宠物</div>
      <!-- 换宠表格 -->
      <el-table
        :data="new_pet_infoList"
        max-height="800"
        style="width: 100%; margin-bottom: 20px"
        row-key="tableKey"
        :tree-props="{ children: 'goodsList', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="宠物" prop="pet_name"></el-table-column>
        <el-table-column prop="eprom_no" label="条码"></el-table-column>
        <el-table-column label="规格" prop="eprom_no"></el-table-column>
        <el-table-column prop="pet_price" label="标准价"></el-table-column>
        <el-table-column label="总金额" prop="pet_price"></el-table-column>
      </el-table>
    </div>
    <div>
      <div class="orderInfo" style="margin: 10px 0px">退换宠物</div>
      <!-- 退宠表格 -->
      <el-table
        :data="pet_infoList"
        max-height="800"
        style="width: 100%; margin-bottom: 20px"
        row-key="tableKey"
        :tree-props="{ children: 'goodsList', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="宠物" prop="pet_name"></el-table-column>
        <el-table-column prop="eprom_no" label="条码"></el-table-column>
        <el-table-column label="规格" prop="eprom_no"></el-table-column>
        <el-table-column prop="pet_price" label="标准价"></el-table-column>
        <el-table-column label="总金额" prop="pet_price"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      new_pet_infoList: [],
      pet_infoList: [],
      detail: {
        user_info: {},
        replace_list: [],
        return_list: [],
        pay_info: {},
      },

      return_yue_info: {
        sales_list: [],
      },
      return_account_info: {
        bank_name: "",
        card_no: "",
        name: "",
      },
      objInfo: {
        create: {
          operation_user: {
            user_id: "",
            user_name: "",
          },
        },

        company_info: {
          shop_name: "",
        },
        new_pet_info: {
          eprom_no: "",
          inside_no: "",
          order_no: "",
          pet_id: "",
          pet_name: "",
          pet_price: null,
          price: 0,
          sales_list: null,
        },
        death_info: {
          death_date: "",
          death_img: [],
          death_remark: "",
        },
        remark: "",
        user_info: {
          nick_name: "",
          user_id: "",
          user_mobile: "",
        },
        return_pet: {
          eprom_no: "",
          inside_no: "",
          order_no: "",
          pet_id: "",
          pet_name: "",
          pet_price: "",
        },
        retrun_order_no: "",
        state: "",
        type: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getTableList();
  },
  methods: {
    getTableList() {
      let params = {
        id: this.$route.query.id,
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_order + "/api/PetReplaceRecord/get",
          params
        )
        .then((res) => {
          this.objInfo = res.data;
          console.log("详情", res.data);
          if (res.data.return_yue_info) {
            this.return_yue_info.sales_list =
              res.data.return_yue_info.sales_list;
          }
          if (res.data.return_account_info) {
            this.return_account_info = res.data.return_account_info;
          }
          if (res.data.new_pet_info) {
            this.new_pet_infoList.push(res.data.new_pet_info);
          }
          if (res.data.return_pet) {
            res.data.return_pet.return_yue_info = res.data.return_yue_info;
            this.pet_infoList.push(res.data.return_pet);
          }
        });
    },
  },
};
</script>
<style scoped lang="scss" >
.orderInfo {
  font-size: 14px;
  // margin: 10px 0px;
  padding: 0 16px;
  margin-bottom: 12px;
  font-weight: bold;
  background-color: #fff;
  border-radius: 4px;
  line-height: 30px;
}
.orderInfoL {
  padding: 0 30px;
  display: flex;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
  font-size: 12px;
  div {
    flex: 1;
  }
}
.msg {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 4px;
  .msgItem {
    width: 25%;
    font-size: 16px;
    color: $fontColor;
    display: flex;
    line-height: 40px;
    padding: 0 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #f2f2f2;
    font-size: 12px;
    .msgLabel {
      width: 80px;
      text-align: right;
      color: $fontColor;
    }

    .msgValue {
    }
  }
}
</style>
